import { z } from 'zod';

const AI_VISIBILITY_DEFAULT = 'https://brand-search-backend-617727402569.asia-south1.run.app';
/** The legacy app's demo-store entry (a tab-scoped sign-in to the shared demo account). */
const DEMO_STORE_DEFAULT = 'https://app.getclevrr.com/auth/demo';

const schema = z.object({
  VITE_API_BASE: z.url().transform((s) => s.replace(/\/+$/, '')),
  VITE_MIXPANEL_TOKEN: z.string().optional().default(''),
  VITE_GOOGLE_CLIENT_ID: z.string().optional().default(''),
  /** The public brand-search service the AI Visibility onboarding step calls (no auth). */
  VITE_AI_VISIBILITY_API_URL: z
    .string()
    .optional()
    .default(AI_VISIBILITY_DEFAULT)
    .transform((s) => (s || AI_VISIBILITY_DEFAULT).replace(/\/+$/, '')),
  /** The "Demo store" link on Connect Data. Backend 2.0 has no demo, so it opens the legacy app's. Empty hides the link. */
  VITE_DEMO_STORE_URL: z.string().optional().default(DEMO_STORE_DEFAULT),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  const issues = parsed.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ');
  throw new Error(`Invalid environment. ${issues}. Copy .env.example to .env.local.`);
}

export const env = parsed.data;
export type Env = typeof env;
